import { render, staticRenderFns } from "./RightsCardContent.vue?vue&type=template&id=37ef1656&"
import script from "./RightsCardContent.vue?vue&type=script&lang=ts&"
export * from "./RightsCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./RightsCardContent.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports